import {messages} from '@smartmixin/i18n';
import type {IntlShape} from 'react-intl';

type FormatMessage = IntlShape['formatMessage'];

/**
 * Every report's title, by its route under `analysis/`. The report list and
 * the breadcrumbs both read it, so a crumb can never name a report
 * differently from the card that opened it (the way STATION_TABS keeps the
 * tab crumbs honest).
 */
export const REPORT_TITLES: Record<string, (f: FormatMessage) => string> = {
  records: (f) => f(messages.reports.recordsAndClimatology),
  'on-this-day': (f) => f(messages.reports.onThisDayInHistory),
  'monthly-outdoor': (f) => f(messages.reports.monthlyOutdoorReport),
  'annual-outdoor': (f) => f(messages.reports.annualOutdoorReport),
  'annual-comparison': (f) => f(messages.reports.annualOutdoorComparison),
  export: (f) => f(messages.reports.dataExport),
  'station-comparison': (f) => f(messages.charts.stationComparison),
  'temperature-feel': (f) =>
    `${f(messages.metrics.temperature)} & ${f(messages.metrics.feelsLike)}`,
  'dew-point': (f) =>
    `${f(messages.metrics.dewPoint)}, ${f(messages.metrics.temperature)} & ${f(messages.metrics.humidity)}`,
  'temperature-comparison': (f) =>
    f(messages.reports.yearToDateTemperatureComparison),
  'wind-monthly': (f) => f(messages.reports.monthlyWindReport),
  'wind-run': (f) => f(messages.metrics.windRun),
  'rain-annual': (f) => f(messages.reports.cumulativeRainfall),
  'rain-comparison': (f) =>
    f(messages.reports.annualCumulativeRainfallComparison),
  'solar-monthly': (f) => f(messages.reports.monthlySolarReport),
  'solar-annual': (f) => f(messages.reports.annualSolarReport),
  'grassland-temperature': (f) => f(messages.reports.grasslandTemperatureSum),
  'annual-water-balance': (f) => f(messages.reports.annualWaterBalance),
};

/** The title of the report at `route`, or undefined for an unknown one. */
export const reportTitle = (route: string, f: FormatMessage) =>
  Object.prototype.hasOwnProperty.call(REPORT_TITLES, route)
    ? REPORT_TITLES[route](f)
    : undefined;
